import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'home',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "home" */'../views/home.vue')
  },
  {
    path: '/login',
    name: 'login',
    meta: { requiresAuth: false },
    component: () => import(/* webpackChunkName: "login" */ '../views/login.vue')
  },
  {
    path: '/redeem',
    name: 'redeem',
    meta: { requiresAuth: false },
    component: () => import(/* webpackChunkName: "event" */ '../views/redeem_event.vue')
  },
  {
    path: '/help',
    name: 'help',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "help" */ '../views/help.vue')
  },
  
  //#region "Subscriptor"
  {
    path: '/register',
    name: 'register',
    meta: { requiresAuth: false },
    component: () => import(/* webpackChunkName: "account" */ '../views/account/register.vue')
  },
  {
    path: '/username-reminder',
    name: 'username-reminder',
    meta: { requiresAuth: false },
    component: () => import(/* webpackChunkName: "account" */ '../views/account/username_reminder.vue')
  },
  {
    path: '/lost-credentials',
    name: 'lost-credentials',
    meta: { requiresAuth: false },
    component: () => import(/* webpackChunkName: "account" */ '../views/account/lost_credentials.vue')
  },
  {
    path: '/password-reset',
    name: 'password-reset',
    meta: { requiresAuth: false },
    component: () => import(/* webpackChunkName: "account" */ '../views/account/password_reset.vue')
  },
  {
    path: '/password-reset-from-key/:key',
    name: 'password-reset-from-key',
    meta: { requiresAuth: false },
    component: () => import(/* webpackChunkName: "account" */ '../views/account/password_reset_from_key.vue')
  },
  {
    path: '/confirm-account/:key',
    name: 'confirm-account',
    meta: { requiresAuth: false },
    component: () => import(/* webpackChunkName: "account" */ '../views/account/confirm_account.vue')
  },
  {
    path: '/cancel-confirm-account/:key',
    name: 'cancel-confirm-account',
    meta: { requiresAuth: false },
    component: () => import(/* webpackChunkName: "account" */ '../views/account/cancel_confirm_account.vue')
  },


  {
    path: '/account',
    name: 'account',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "account" */ '../views/account/account.vue')
  },
  {
    path: '/account/change-password',
    name: 'password-change',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "account" */ '../views/account/password_change.vue')
  },
  {
    path: '/account/close',
    name: 'close-account',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "account" */ '../views/account/close_account.vue')
  },
  //#endregion
  
  //#region "Entities"
  {
    path: '/entities',
    name: 'entities',
    meta: { requiresAuth: true, loadRemoteData: true },
    component: () => import(/* webpackChunkName: "entities" */ '../views/entities/entities.vue')
  },
  {
    path: '/entities/all',
    name: 'entities_all',
    meta: { requiresAuth: true, loadRemoteData: true, requiresAdmin: true  },
    component: () => import(/* webpackChunkName: "entities" */ '../views/entities/entities_all.vue')
  },
  {
    path: '/entities/add',
    name: 'entities_add',
    meta: { requiresAuth: true, requiresAdmin: true   },
    component: () => import(/* webpackChunkName: "entities" */ '../views/entities/entity_add.vue')
  },
  //#region "Distributors"
  {
    path: '/entities/distributors/add',
    name: 'distributor_add',
    meta: { requiresAuth: true, loadRemoteData: true, requiresAdmin: true   },
    component: () => import(/* webpackChunkName: "entities" */ '../views/entities/distributor_form.vue')
  },
  {
    path: '/entities/distributors/:id',
    name: 'distributor_detail',
    meta: { requiresAuth: true, loadRemoteData: true },
    component: () => import(/* webpackChunkName: "entities" */ '../views/entities/distributor_detail.vue')
  },
  {
    path: '/entities/distributors/:id/edit',
    name: 'distributor_edit',
    meta: { requiresAuth: true, loadRemoteData: true  },
    component: () => import(/* webpackChunkName: "entities" */ '../views/entities/distributor_form.vue')
  },
  //#endregion
  //#region "Structures"
  {
    path: '/entities/structures/add',
    name: 'structure_add',
    meta: { requiresAuth: true, loadRemoteData: true },
    component: () => import(/* webpackChunkName: "entities" */ '../views/entities/structure_form.vue')
  },
  {
    path: '/entities/structures/:id',
    name: 'structure_detail',
    meta: { requiresAuth: true, loadRemoteData: true },
    component: () => import(/* webpackChunkName: "entities" */ '../views/entities/structure_detail.vue')
  },
  {
    path: '/entities/structures/:id/edit',
    name: 'structure_edit',
    meta: { requiresAuth: true, loadRemoteData: true  },
    component: () => import(/* webpackChunkName: "entities" */ '../views/entities/structure_form.vue')
  },
  //#endregion
  //#region "Game Fields"
  {
    path: '/entities/game_fields/add',
    name: 'game_field_add',
    meta: { requiresAuth: true, loadRemoteData: true  },
    component: () => import(/* webpackChunkName: "entities" */ '../views/entities/game_field_form.vue')
  },
  {
    path: '/entities/game_fields/:id',
    name: 'game_field_detail',
    meta: { requiresAuth: true, loadRemoteData: true  },
    component: () => import(/* webpackChunkName: "entities" */ '../views/entities/game_field_detail.vue')
  },
  {
    path: '/entities/game_fields/:id/edit',
    name: 'game_field_edit',
    meta: { requiresAuth: true, loadRemoteData: true  },
    component: () => import(/* webpackChunkName: "entities" */ '../views/entities/game_field_form.vue')
  },
  //#endregion
  //#region "Clubs"
  {
    path: '/entities/clubs/add',
    name: 'club_add',
    meta: { requiresAuth: true, loadRemoteData: true , requiresAdmin: true  },
    component: () => import(/* webpackChunkName: "entities" */ '../views/entities/club_form.vue')
  },
  {
    path: '/entities/clubs/:id',
    name: 'club_detail',
    meta: { requiresAuth: true, loadRemoteData: true },
    component: () => import(/* webpackChunkName: "entities" */ '../views/entities/club_detail.vue')
  },
  {
    path: '/entities/clubs/:id/edit',
    name: 'club_edit',
    meta: { requiresAuth: true, loadRemoteData: true  },
    component: () => import(/* webpackChunkName: "entities" */ '../views/entities/club_form.vue')
  },
  //#endregion
  //#region "Teams"
  {
    path: '/entities/teams/add',
    name: 'team_add',
    meta: { requiresAuth: true, loadRemoteData: true  },
    component: () => import(/* webpackChunkName: "entities" */ '../views/entities/team_form.vue')
  },
  {
    path: '/entities/teams/:id',
    name: 'team_detail',
    meta: { requiresAuth: true, loadRemoteData: true  },
    component: () => import(/* webpackChunkName: "entities" */ '../views/entities/team_detail.vue')
  },
  {
    path: '/entities/teams/:id/edit',
    name: 'team_edit',
    meta: { requiresAuth: true, loadRemoteData: true  },
    component: () => import(/* webpackChunkName: "entities" */ '../views/entities/team_form.vue')
  },
  //#endregion
  //#region "Users"
  {
    path: '/users',
    name: 'users',
    meta: { requiresAuth: true, loadRemoteData: true  },
    component: () => import(/* webpackChunkName: "entities" */ '../views/entities/users.vue')
  },
  {
    path: '/users/add',
    name: 'user_add',
    meta: { requiresAuth: true, loadRemoteData: true  },
    component: () => import(/* webpackChunkName: "entities" */ '../views/entities/user_form.vue')
  },
  {
    path: '/users/:id',
    name: 'user_detail',
    meta: { requiresAuth: true, loadRemoteData: true  },
    component: () => import(/* webpackChunkName: "entities" */ '../views/entities/user_detail.vue')
  },
  {
    path: '/users/:id/edit',
    name: 'user_edit',
    meta: { requiresAuth: true, loadRemoteData: true  },
    component: () => import(/* webpackChunkName: "entities" */ '../views/entities/user_form.vue')
  },
  //#endregion

  //#endregion

  //#region "MyVideos"
  {
    path: '/videos',
    name: 'videos',
    meta: { requiresAuth: true, loadRemoteData: true },
    component: () => import(/* webpackChunkName: "videos" */ '../views/videos/videos.vue')
  },
  {
    path: '/videos/clips/by-event/:id',
    name: 'clip_detail',
    meta: { requiresAuth: true, loadRemoteData: true },
    component: () => import(/* webpackChunkName: "clips" */ '../views/videos/clips_by_event.vue')
  },
  {
    path: '/videos/clip/:id',
    name: 'clip_detail',
    meta: { requiresAuth: true, loadRemoteData: true },
    component: () => import(/* webpackChunkName: "clips" */ '../views/videos/clip_detail.vue')
  },
  {
    path: '/videos/highlight/:id',
    name: 'highlight_detail',
    meta: { requiresAuth: true, loadRemoteData: true },
    component: () => import(/* webpackChunkName: "highlights" */ '../views/videos/highlight_detail.vue')
  },
  //#endregion

  //#region "Events"
  {
    path: '/events',
    name: 'events',
    meta: { requiresAuth: true, loadRemoteData: true },
    component: () => import(/* webpackChunkName: "event" */ '../views/events/events.vue')
  },
  {
    path: '/events/all',
    name: 'events_all',
    meta: { requiresAuth: true, loadRemoteData: true, requiresAdmin: true  },
    component: () => import(/* webpackChunkName: "event" */ '../views/events/events_all.vue')
  },
  {
    path: '/events/calendar',
    name: 'calendar',
    meta: { requiresAuth: true, loadRemoteData: true  },
    component: () => import(/* webpackChunkName: "calendar" */ '../views/events/events_calendar.vue')
  },
  {
    path: '/events/add',
    name: 'event_add',
    meta: { requiresAuth: true, loadRemoteData: true  },
    component: () => import(/* webpackChunkName: "event_create" */ '../views/events/event_create.vue')
  },
  {
    path: '/events/live',
    name: 'event_live',
    meta: { requiresAuth: true, loadRemoteData: true  },
    component: () => import(/* webpackChunkName: "event_live" */ '../views/events/event_live.vue')
  },
  {
    path: '/events/:id',
    name: 'event_detail',
    meta: { requiresAuth: true, loadRemoteData: true },
    component: () => import(/* webpackChunkName: "event_detail" */ '../views/events/event_detail.vue')
  },
  {
    path: '/events/:id/edit',
    name: 'event_detail',
    meta: { requiresAuth: true, loadRemoteData: true },
    component: () => import(/* webpackChunkName: "event_detail" */ '../views/events/event_edit.vue')
  },
  {
    path: '/watch/:id',
    name: 'event_watch',
    meta: { requiresAuth: false, loadRemoteData: true },
    component: () => import(/* webpackChunkName: "event_detail" */ '../views/videos/clips_by_event.vue')
  },
  
  {
    path: '/categories',
    name: 'categories',
    meta: { requiresAuth: true, loadRemoteData: true  },
    component: () => import(/* webpackChunkName: "categories" */ '../views/categories/categories.vue')
  },
  {
    path: '/categories/add',
    name: 'category_add',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "categories" */ '../views/categories/category_form.vue')
  },
  {
    path: '/categories/:id',
    name: 'category_detail',
    meta: { requiresAuth: true, loadRemoteData: true  },
    component: () => import(/* webpackChunkName: "categories" */ '../views/categories/category_detail.vue')
  },
  {
    path: '/categories/:id/edit',
    name: 'category_edit',
    meta: { requiresAuth: true, loadRemoteData: true  },
    component: () => import(/* webpackChunkName: "categories" */ '../views/categories/category_form.vue')
  },

  {
    path: '/seasons',
    name: 'seasons',
    meta: { requiresAuth: true, loadRemoteData: true  },
    component: () => import(/* webpackChunkName: "seasons" */ '../views/seasons/seasons.vue')
  },
  {
    path: '/seasons/add',
    name: 'season_add',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "seasons" */ '../views/seasons/season_form.vue')
  },
  {
    path: '/seasons/:id',
    name: 'season_detail',
    meta: { requiresAuth: true, loadRemoteData: true  },
    component: () => import(/* webpackChunkName: "seasons" */ '../views/seasons/season_detail.vue')
  },
  {
    path: '/seasons/:id/edit',
    name: 'season_edit',
    meta: { requiresAuth: true, loadRemoteData: true  },
    component: () => import(/* webpackChunkName: "seasons" */ '../views/seasons/season_form.vue')
  },

  {
    path: '/relations',
    name: 'relations',
    meta: { requiresAuth: true, loadRemoteData: true  },
    component: () => import(/* webpackChunkName: "relations" */ '../views/relations/relations.vue')
  },
  {
    path: '/relations/:id',
    name: 'relation_detail',
    meta: { requiresAuth: true, loadRemoteData: true  },
    component: () => import(/* webpackChunkName: "relations" */ '../views/relations/relation_detail.vue')
  },

  {
    path: '/hibox',
    name: 'hibox',
    meta: { requiresAuth: true, loadRemoteData: true  },
    component: () => import(/* webpackChunkName: "hibox" */ '../views/hibox/list.vue')
  },
  {
    path: '/hibox/discovery',
    name: 'hibox_discovery',
    meta: { requiresAuth: true, loadRemoteData: true  },
    component: () => import(/* webpackChunkName: "hibox" */ '../views/hibox/discovery.vue')
  },
  {
    path: '/hibox/:id',
    name: 'hibox_detail',
    meta: { requiresAuth: true, loadRemoteData: true  },
    component: () => import(/* webpackChunkName: "hibox" */ '../views/hibox/hibox_detail.vue')
  },
  //legacy

  {
    path: '/higoalbox',
    name: 'higoalbox',
    meta: { requiresAuth: true, loadRemoteData: true  },
    component: () => import(/* webpackChunkName: "hibox" */ '../views/hibox/list.vue')
  },
  {
    path: '/higoalbox/discovery',
    name: 'higoalbox_discovery',
    meta: { requiresAuth: true, loadRemoteData: true  },
    component: () => import(/* webpackChunkName: "hibox" */ '../views/hibox/discovery.vue')
  },
  {
    path: '/higoalbox/:id',
    name: 'higoalbox_detail',
    meta: { requiresAuth: true, loadRemoteData: true  },
    component: () => import(/* webpackChunkName: "hibox" */ '../views/hibox/hibox_detail.vue')
  },
  //\legacy

  {
    path: '/sports/:id_sport',
    name: 'sports',
    meta: { requiresAuth: true, loadRemoteData: true  },
    component: () => import(/* webpackChunkName: "sports" */ '../views/sports/sports.vue')
  }
  //#endregion
]

const router = new VueRouter({
  routes
})
export default router
